module.exports = __webpack_public_path__ + "img/eiskaffeeohnehintergrund.b8385481.png";